import React, { useState, useRef } from "react";

const CodeBlock = ({ language, children }) => {
  const [copied, setCopied] = useState(false);
  const preRef = useRef(null);

  const handleCopy = async () => {
    const code = preRef.current?.innerText || "";
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error("Copy failed", e);
    }
  };

  return (
    <div className="md-code-block">
      <div className="md-code-header">
        <span className="md-code-lang">{language || "text"}</span>
        <button type="button" className="md-code-copy" onClick={handleCopy}>
          <span className="material-icons">
            {copied ? "check" : "content_copy"}
          </span>
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <div ref={preRef}>{children}</div>
    </div>
  );
};

export default CodeBlock;
